import { render } from "./SwipeRow.vue?vue&type=template&id=32a8070c&scoped=true"
import script from "./SwipeRow.vue?vue&type=script&lang=js"
export * from "./SwipeRow.vue?vue&type=script&lang=js"

import "./SwipeRow.vue?vue&type=style&index=0&id=32a8070c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a8070c"]])

export default __exports__